<template>
  <div class="questions-list__question-value">
    <div v-if="question.options.length > 0">
      <multiselect
        v-model="value"
        :options="question.options"
        track-by="id"
        label="name"
        :allowEmpty="allowEmpty"
        :multiple="false"
        :close-on-select="true"
        :show-labels="false"
        openDirection="top"
        @input="changeValue($event)"
      >
      </multiselect>
      <div v-if="(score / question.question_weight) * 100 < 100 && value">
        <br />
        <label class="control-label">In consideration, budgeted for or planned to be done soon? </label> <br />
        <input
          type="radio"
          :id="'planned_yes_' + answer.id"
          :value="1"
          v-model="answer.planned"
          @input="changeValue(answer.value)"
        />
        Yes
        <input
          type="radio"
          :id="'planned_no_' + answer.id"
          :value="0"
          v-model="answer.planned"
          @input="changeValue(answer.value)"
        />
        No
      </div>
    </div>
    <div v-else>
      <div v-if="question.unit.type === 'slider'">
        <vue-slider
          v-model="value"
          :marks="getDataForSlider(question.score_range)"
          height="12px"
          @change="changeValue($event)"
        >
        </vue-slider>
        <div v-if="(score / question.question_weight) * 100 < 100 && value">
          <br />
          <br />
          <label class="control-label">Do you plan to improve this percentage? </label> <br />
          <input
            type="radio"
            :id="'planned_yes_' + answer.id"
            :value="1"
            v-model="answer.planned"
            @input="changeValue(answer.value)"
          />
          Yes
          <input
            type="radio"
            :id="'planned_no_' + answer.id"
            :value="0"
            v-model="answer.planned"
            @input="changeValue(answer.value)"
          />
          No
        </div>
      </div>
      <div v-else>
        <fg-input
          type="text"
          class="-mt-12"
          :label="question.unit.name"
          :placeholder="question.unit.name"
          v-model="value"
          @input="changeValue($event)"
        >
        </fg-input>
        <div v-if="(score / question.question_weight) * 100 < 100 && value">
          <br />
          <label class="control-label">Do you plan to improve this number? </label> <br />
          <input
            type="radio"
            :id="'planned_yes_' + answer.id"
            :value="1"
            v-model="answer.planned"
            @input="changeValue(answer.value)"
          />
          Yes
          <input
            type="radio"
            :id="'planned_no_' + answer.id"
            :value="0"
            v-model="answer.planned"
            @input="changeValue(answer.value)"
          />
          No
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionAnswerController from '@/controllers/QuestionAnswer/QuestionAnswerController';
import ScoreController from '@/controllers/Score/ScoreController';

export default {
  name: 'AnswerField',
  props: {
    question: Object,
    answer: Object,
    company: Object,
    allowEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: null,
      score: null,
    };
  },
  watch: {
    answer(NewVal) {
      this.setData(NewVal);
    },
  },
  mounted() {
    this.setData(this.answer);
  },
  methods: {
    changeValue(newVal) {
      let vm = this;
      this.$gtag.event('Answer Saved', { method: 'Google' });
      delay(async function () {
        let achieved_weight = await vm.calcScore(newVal);
        try {
          if (newVal !== null) {
            await QuestionAnswerController.store({
              question_id: vm.question.id,
              related_to: vm.company.company_id,
              value: newVal,
              achieved_weight: achieved_weight,
              skipped: false,
              planned: vm.answer.planned,
            });
          } else {
            await QuestionAnswerController.destroy(vm.answer.id);
          }
          vm.$emit('saved', newVal);
          vm.$notify({
            type: 'success',
            title: 'Saved!',
          });
        } catch (error) {
          console.error(error);
          vm.$notify({
            type: 'danger',
            title: 'Was not saved!',
          });
        }
      }, 500);
    },
    async calcScore(value) {
      this.score = await ScoreController.calculateScore(value, this.question);
      return this.score;
    },
    getDataForSlider(range) {
      return {
        0: {
          label: '0%',
          labelStyle: {
            color: '#EB5E28',
          },
        },
        50: {
          label: '50%',
          labelStyle: {
            color: '#FFC20E',
          },
        },
        100: {
          label: '100%',
          labelStyle: {
            color: '#73AB6B',
          },
        },
      };
    },
    setData(answer) {
      this.value = answer.value;
      this.calcScore(this.value);
      this.visible = !answer.skipped;
    },
  },
};

let delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
</script>

<style scoped></style>
